var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1867 15.781C17.9132 15.781 18.2765 14.9334 17.7518 14.4087L12.5853 9.24218C12.2624 8.91927 11.7376 8.91927 11.4147 9.24218L6.24824 14.4087C5.72352 14.9334 6.08679 15.781 6.81333 15.781H17.1867Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarretUp);
export default __webpack_public_path__ + "static/media/carret-up.4927e2614b4bf222dca2aa0d6afde452.svg";
export { ForwardRef as ReactComponent };